import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const IntroIndicatorWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-top: 3vh;
  span {
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 0;
  }

  svg {
    width: 3.5rem;
    stroke: ${props => props.theme.color.secondaryIntense};
    margin-bottom: 1rem;
  }
`

export const IntroSlider = styled.div`
  padding: 5vh 0;
  .marquee-container {
    .marquee {
      display: flex;
    }
  }
`

export const IntroSliderImage = styled.div<{ variant?: string }>`
  margin-top: auto;
  width: 100%;
  height: min(26rem, 30vh);
  display: flex;
  padding: 0 4vw;

  ${props =>
    props.theme.fontSize === 'lg' &&
    css`
      height: min(26rem, 25vh);
    `};
  padding: 0 4vw;

  ${props =>
    props.theme.fontSize === 'xl' &&
    css`
      height: min(26rem, 23vh);
    `};

  img {
    display: block;
    height: 95%;
    width: 100%;
    object-fit: contain;
  }
`

export const IntroLogo = styled.div`
  svg {
    height: 18rem;
    margin: 0 auto;
    display: block;
    fill: currentColor;

    ${props =>
      props.theme.fontSize === 'lg' &&
      css`
        height: 15rem;
      `};
    ${props =>
      props.theme.fontSize === 'xl' &&
      css`
        height: 12rem;
      `};
  }
`

export const IntroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  background: ${props => props.theme.color.primaryDark};
  color: ${props => props.theme.color.inverted};
  padding-top: ${props => props.theme.spacing.md};
  padding-bottom: ${props => props.theme.spacing.md};
  cursor: pointer;
`

export const IntroTitle = styled.h1`
  font-size: calc(6rem + 3vh);
  text-align: center;
  color: ${props => props.theme.color.inverted};
`

export const IntroIndicator = styled.div`
  margin: 3vh auto 0;
`

export const IntroToggler = styled.button`
  ${Reset('button')}
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 100;
  width: 4.5rem;
  height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(30px);
  color: ${props => props.theme.color.inverted};

  > span {
    position: absolute;
    right: 100%;
    margin-right: 1rem;
    white-space: nowrap;
    font-size: 0.9rem;
    font-weight: 600;
    color: ${props => props.theme.color.inverted};
    visibility: hidden;
  }

  ${props =>
    props.theme.accessibilityMode &&
    css`
      bottom: auto;
      top: 1rem;
      background-color: ${props => props.theme.color.inverted};
      color: ${props => props.theme.color.primary};

      > span {
        visibility: visible;
      }
    `};

  svg {
    width: 45%;
    height: 45%;
    fill: currentColor;
  }
`

export const IntroError = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.color.primaryDark};
  backdrop-filter: blur(15px);
  color: ${props => props.theme.color.inverted};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 1rem 5%;
  z-index: 1000;
  font-size: 3rem;

  > video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    opacity: 0.4;
  }

  ${props =>
    props.theme.contrastMode &&
    css`
      background-color: rgba(0, 0, 0, 0.8);
    `};
`

export const IntroTimer = styled.div`
  display: block;
  margin-top: 2rem;
  font-size: 2em;
`
